import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const anchor = document.getElementById('cta-hero');
    if (!anchor) return;
    const observer = new IntersectionObserver(([entry]) => {
      // Show once the first CTA has scrolled out of view upwards.
      setVisible(!entry.isIntersecting && entry.boundingClientRect.top < 0);
    }, {
      threshold: 0
    });
    observer.observe(anchor);
    return () => observer.disconnect();
  }, []);
  return <AnimatePresence data-id="element-33" data-mp="bprclbel7xjv">
      {visible && <motion.div initial={{
      y: 80,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 80,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 px-3 pb-3" data-id="element-34" data-mp="boom34l6fx4h">
          <div className="mx-auto max-w-md" data-id="element-35" data-mp="2b38rjkh3qwuy">
            <a href={CHECKOUT_URL} className="flex animate-shake items-center justify-center gap-2 rounded-xl bg-brand-500 px-4 py-4 text-center font-display text-[14px] font-extrabold uppercase tracking-tight text-white shadow-[0_-6px_28px_-6px_rgba(5,15,31,0.55),0_10px_26px_-8px_rgba(31,116,232,0.7)] transition-colors duration-150 ease-out hover:bg-brand-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-300 sm:text-base" data-id="element-36" data-mp="2f3sl6e2gvicc">
              Get instant access — $27 today
              <ArrowRightIcon aria-hidden="true" className="h-5 w-5 shrink-0" data-id="element-37" data-mp="1ig4h2zz8pqbs" />
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}